import {
  SelectionTypeSchema,
  type SelectionType as GeneratedSelectionType
} from '~/services/api/generated'

export type SelectionType = GeneratedSelectionType

export const SelectionType = {
  SINGLE: SelectionTypeSchema.enum.single,
  MULTIPLE: SelectionTypeSchema.enum.multiple
} satisfies Record<string, GeneratedSelectionType>

export const SelectionTypeValues: readonly GeneratedSelectionType[] = [
  SelectionTypeSchema.enum.single,
  SelectionTypeSchema.enum.multiple
]
